import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-trip-wizard-step1',
  templateUrl: './connect-trip-wizard-step1.component.html',
  styleUrls: ['./connect-trip-wizard-step1.component.scss'],
})
export class ConnectTripWizardStep1Component implements OnInit {
  @Output() next = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
